/** 多语言违禁词库契约：仅识别与改写投放内容，不改变源书正文。 */
import { z } from 'zod';
export const ProhibitedTermInputSchema = z
  .object({
    term: z.string().trim().min(1).max(256),
    language: z
      .string()
      .trim()
      .max(32)
      .transform((value) => value.toLowerCase())
      .pipe(z.string().regex(/^(?:\*|[a-z]{2,3}(?:-[A-Za-z0-9]{2,8})*)$/)),
    illegal_type: z.string().trim().min(1).max(64),
    match_mode: z.enum(['whole_word', 'substring']).default('whole_word'),
    enabled: z.boolean().default(true),
    notes: z.string().trim().max(1000).default(''),
  })
  .strict();
export const ProhibitedTermsImportSchema = z
  .object({ items: z.array(ProhibitedTermInputSchema).min(1).max(500) })
  .strict();
export const ProhibitedTermsQuerySchema = z.object({
  q: z.string().trim().max(256).optional(),
  language: z
    .string()
    .trim()
    .max(32)
    .transform((value) => value.toLowerCase())
    .optional(),
  enabled: z.enum(['true', 'false']).optional(),
  offset: z.coerce.number().int().min(0).default(0),
  limit: z.coerce.number().int().min(1).max(100).default(20),
});
export type ProhibitedTermInput = z.infer<typeof ProhibitedTermInputSchema>;
export type ProhibitedTermDto = ProhibitedTermInput & {
  id: string;
  created_at: string;
  updated_at: string;
};
export type ProhibitedTermsPage = {
  items: ProhibitedTermDto[];
  total: number;
  offset: number;
  limit: number;
};
